import React from "react";
import { NewTab, PageTab, PageTabAdv } from "../../../components";
import BulkEmails from "./Campaign/BulkEmails";
import EmailTemplates from "./Campaign/EmailTemplates";
import Assign from "./Campaign/Assign";
import FollowUpAssign from "./Campaign/FollowUpAssign";
import { useModuleAccess } from "../../../hooks";

const Campaigns = () => {
  const LeadsMenus = [
    {
      title: "Bulk Emails",
      page: <BulkEmails />,
      type: "main",
      id: "campaigns_bulkemails",
    },
    {
      title: "Email Templates",
      page: <EmailTemplates />,
      type: "main",
      subTabs: [
        {
          title: "Refresh",
          icon: "refresh",
          action: console.log("click"),
        },
      ],
      id: "campaigns_emailtemplates",
    },
    {
      title: "Assign",
      page: <Assign />,
      type: "main",
      id: "campaigns_assign",
    },
    {
      title: "FollowUp Assign",
      page: <FollowUpAssign />,
      type: "main",
      id: "campaigns_followupassign",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: LeadsMenus,
    parentId: "campaigns",
  });
  return (
    <div className="flex-1 flex  overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="campaigns"
      />
    </div>
  );
};

export default Campaigns;
